import { StyledDialogActions } from 'components/atoms/styledModal';
import AnimatedDotsText from 'components/atoms/AnimatedDotsText';
import StyledButton from 'components/atoms/StyledButton';

const DialogActionFooter = ({
  onCancel,
  onConfirm,
  confirmLabel = 'Confirm',
  confirmingLabel = 'Updating',
  cancelLabel = 'Cancel',
  isConfirming = false,
  disabled = false
}) => {
  return (
    <StyledDialogActions>
      <StyledButton onClick={onCancel} className="cancelButton" disabled={disabled}>
        {cancelLabel}
      </StyledButton>
      <StyledButton onClick={onConfirm} className="confirmButton" disabled={disabled}>
        {isConfirming ? <AnimatedDotsText text={confirmingLabel} /> : confirmLabel}
      </StyledButton>
    </StyledDialogActions>
  );
};

export default DialogActionFooter;
